export default Object.freeze({
	LABOUR_HIRE_FIRM: '1',
	NOT_A_LABOUR_HIRE_FIRM: '2',
	GROUP_TRINING_APPRENTICESHIP_SCHEME: '3',
});
